import React from 'react'
import './experience.css';
import timelineElements from '../../timelineElements';
import { ReactComponent as WorkIcon} from '../../work.svg';
import { ReactComponent as SchoolIcon} from '../../school.svg';
import{
    VerticalTimeline,
    VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
const Experience = () => {
    let workIconStyles = {background: '#06D6A0'}
    let schoolIconStyles = {background: '#ffeb95'}
  return (
    <div>
        <section id='Experience'>
            <div className='container mt-5'>
                <div className='text-center mb-4'>
                    <h1>Work <span className="introText">Experience</span></h1>
                </div>
                <VerticalTimeline>
                    {       
                        timelineElements.map(element => {
                            let isWorkIcon = element.icon === 'work';
                            return (
                                <VerticalTimelineElement
                                key={element.key}
                                date={element.date}
                                dateClassName='date'  
                                iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
                                className={element.id === 4 ? 'education-element' : ''}
                                icon={isWorkIcon ? <WorkIcon/> : <SchoolIcon/>}
                                >
                                    <h5 className='vertical-timeline-element-title'>{element.title}</h5>
                                    <h6 className='vertical-timeline-element-company'>{element.company}</h6>
                                    <p className='vertical-timeline-element-description'>{element.description}</p>
                                </VerticalTimelineElement>
                            )
                        })
                    }
                </VerticalTimeline>
            </div>
        </section>
      
    </div>
  )
}

export default Experience
